export default __webpack_public_path__ + "static/open-graph-image-19cca979b0e3551b546f5a55e011d046.jpg";